<script setup>
import {useForm} from "laravel-precognition-vue-inertia";
import {ref} from "vue";
import { trans } from 'laravel-vue-i18n';
import {usePage} from "@inertiajs/vue3";
import Button from "primevue/button";
import SubscriptionSettings from "./SubscriptionSettings.vue";
import EmailSettings from "./EmailSettings.vue";
import Avatar from "primevue/avatar";
import AccountSettings from "./AccountSettings.vue";
const props = usePage().props;
const form = useForm('post', '/app/settings', {
    smtp_server: props.settings?.smtp_server,
    smtp_port: props.settings?.smtp_port,
    smtp_username: props.settings?.smtp_username,
    smtp_password: props.settings?.smtp_password,
    smtp_encryption: props.settings?.smtp_encryption,
    smtp_address: props.settings?.smtp_address,
    smtp_name: props.settings?.smtp_name,
    // User account
    user_name: props.settings?.user_name,
    user_password: '',
});
const currentTab = ref('account')

const tabs = [
    {
        label: trans('settings.tab_account'),
        label_mobile: trans('settings.tab_account_short'),
        icon: 'pi pi-user',
        id: 'account'
    },
    {
        label: trans('settings.tab_email'),
        label_mobile: trans('settings.tab_email'),
        icon: 'pi pi-envelope',
        id: 'email'
    },
    {
        label: trans('settings.tab_subscription'),
        label_mobile: trans('settings.tab_subscription'),
        icon: 'pi pi-dollar',
        id: 'subscription'
    },
];
const visible = defineModel();
</script>

<template>
    <div class="overflow-hidden md:rounded-xl flex max-md:flex-col h-full">
        <div class="md:hidden bg-neutral-100 dark:bg-neutral-900 dark:border-neutral-700 px-4 py-2 flex justify-between items-center border-b">
            <p class="text-xl font-bold">{{ $t('common.settings') }}</p>
            <Button icon="pi pi-times" text rounded severity="secondary" @click="visible = false"></Button>
        </div>
        <div class="flex md:flex-col gap-8 bg-gray-50 dark:bg-gray-950 dark:border-neutral-700 md:border-r max-md:border-b p-2 md:p-6 md:h-full md:w-1/3">
            <p class="max-md:hidden text-xl font-bold">{{ $t('common.settings') }}</p>
            <ul class="flex md:flex-col max-md:justify-around gap-2 grow ">
                <li v-for="(item, index) in tabs" @click="currentTab = item.id"
                    :class="currentTab === item.id ? 'font-semibold md:dark:border-r-4 dark:bg-neutral-900 dark:border-blue-800': 'text-gray-600 dark:text-gray-200'"
                    class="flex md:gap-3 max-md:gap-1.5 transition-all max-md:flex-col max-md:text-center max-md:pt-2 items-center hover:bg-gray-100 dark:hover:bg-gray-900 rounded-md cursor-pointer hover:shadow-sm px-2 md:-ml-2 py-0.5">
                    <i :class="[item.icon, currentTab === item.id ? 'text-roori-blue' : 'text-gray-500']"></i>
                    <p class="max-md:hidden">{{ item.label }}</p>
                    <p class="text-sm md:hidden">{{ item.label_mobile }}</p>
                </li>
            </ul>

            <div class="max-md:hidden sidebar-container flex flex-col justify-end">
                <div class="border dark:border-neutral-700 rounded-xl p-4 -m-2 flex gap-2">
                    <Avatar v-if="$page.props.user" :label="$page.props.user_initials" shape="circle"
                            :image="profile?.url" class="border dark:border-neutral-700" size="normal"/>
                    <div class="grow">
                        <p class="text-sm font-bold">{{ $page.props.user.name }}</p>
                        <p class="text-xs opacity-50">{{ $page.props.user.subscription?.edition_name ?? $t('common.no_plan_selected') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="md:w-2/3 max flex flex-col overflow-hidden max-md:grow relative">
            <div class="max-md:hidden flex justify-between border-b dark:border-neutral-700 w-full p-4 items-center">
                <p class="text-xl ml-2">{{ tabs.find(t => t.id === currentTab)?.label }}</p>
                <Button icon="pi pi-times" rounded severity="secondary" @click="visible = false"></Button>
            </div>
            <div class="grow overflow-y-scroll overflow-x-hidden">
                <transition-group name="list">
                    <account-settings v-if="currentTab === 'account'" v-model:modal="visible"
                                      v-model="form"></account-settings>
                    <email-settings v-else-if="currentTab === 'email'" v-model="form"></email-settings>
                    <subscription-settings v-else-if="currentTab === 'subscription'"></subscription-settings>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
